<style lang="scss" scoped>
.tribe-box-banner {
    position: relative;
    width: 100%;
    cursor: pointer;

    @media (min-width: 768px) {
        height: 360px;
    }

    &:after {
        content: "";
        z-index: 1;
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            225deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.5) 100%
        );

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";

        position: absolute;
        top: 0;
        left: 0;

        @media (min-width: 768px) {
            position: relative;
            top: unset;
            left: unset;
        }

        @media (min-width: 768px) {
            border-radius: 8px;
        }
    }

    .content {
        position: relative;
        z-index: 2;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 24px;

        @media (min-width: 768px) {
            height: 100%;
            padding: 0 24px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }

        @media (min-width: 1024px) {
            padding: 0 56px;
        }

        .title {
            white-space: nowrap;
            line-height: 1;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .description {
            font-size: 1.25rem;
            line-height: 1.5rem;
            max-width: 550px;
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="mb-40 d-flex flex-wrap w-100" v-if="title">
            <h3 class="title" v-html="title"></h3>
            <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
        </div>
        <div class="d-block position-relative" @click.prevent="toggleSlideout">
            <div class="mx-n24 mx-md-0">
                <div class="tribe-box-banner">
                    <img v-if="tribeBox.acf.image" :src="tribeBox.acf.image.url" :alt="tribeBox.post_title">
                    <div class="content">
                        <h2 class="mb-8 text-white title">{{ tribeBox.post_title }}</h2>
                        <div v-if="tribeBox.acf.description" class="text-white font-weight-light description" v-html="tribeBox.acf.description"></div>
                        <span class="btn btn-accent mt-24 align-self-start">Vraag offerte aan <span v-html="svg('arrow-right', 'arrow-right')" /></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hasCta from "../mixins/has-cta";
import { bus } from '@/app';

export default {
    name: "pagePart.tribe-box-banner-row",

    mixins: [hasCta],

    props: {
        title: {
            type: String,
            required: false,
        },
        tribeBox: {
            type: Object,
            required: false,
            default: () => {
                return {
                    title: '',
                    description: '',
                    image: '',
                    tags: [],
                    media: [],
                    link: ''
                };
            },
        },
        src: {
            type: String,
            required: false,
            default: '',
        },
        alt: {
            type: String,
            required: false,
            default: 'Inspire Your Tribe',
        },
        categoryFilterId: {
            type: Number,
            default: null,
        },
        pages: {
            type: Array,
            required: false,
            default: null
        },
    },

    data: (vm) => ({
        orders: {
            tribeBoxes: [vm.tribeBox]
        }
    }),

    methods: {
        toggleSlideout() {
            this.$root.slideoutIsOpen = !this.$root.slideoutIsOpen;
            bus.$emit('orderSlideout', { orders: this.orders, formType: 'tribeBoxes' });
        },
    }
}
</script>